<template>
  <ul class="sc-variants">
    <li
      v-for="(variant, index) in variants"
      :key="variant.slug"
      class="sc-variants__item"
      :class="{ 'sc-variants__item--active': variant?.active }"
    >
      <button
        class="sc-variants__button"
        :class="{ 'sc-variants__button--active': variant?.active }"
        :style="`--color-pagination: ${variant?.color?.code}`"
        :aria-label="variant?.offer?.scopedProduct?.color?.name"
        @click="clickedVariant(index)"
      />
      <span class="sc-variants__color-label">{{ variant?.offer.scopedProduct.color.name }}</span>
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({
  variants: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:currentIndex']);

function clickedVariant(index) {
  props.variants.forEach((item, keyIndex) => {
    // eslint-disable-next-line no-param-reassign
    item.active = index === keyIndex;
    emit('update:currentIndex', index);
  });
}
</script>

<style scoped lang="scss">
@use 'assets/base' as *;

.sc-variants {
  list-style: none;
  display: flex;
  grid-gap: 1rem;
  justify-content: center;
  padding-bottom: 1rem;
  margin-bottom: 6 * $grid-base;
  @include mq($mq-sm) {
    margin-bottom: 4 * $grid-base;
  }
  @include mq($mq-md) {
    margin-bottom: 0;
  }
  &__button {
    background: var(--color-pagination);
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    border: 1px solid #a3a3a3;
    @include mq($mq-sm) {
      width: 37px;
      height: 37px;
    }

    &:after {
      transition: all ease 600ms;
      content: '';
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%);
      width: 0;
      height: 0;
      border: none;
      display: block;
      border-radius: 50%;
    }

    &--active {
      &:after {
        width: calc(100% + 10px);
        height: calc(100% + 10px);
        border: 2px solid var(--color-primary);
      }
    }
  }

  &__color-label {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    width: max-content;
    opacity: 0;
    transition: all ease 500ms;
    @include font-size(16px, 18px);
  }

  &__item {
    position: relative;
    &--active {
      :deep(.sc-variants__color-label) {
        @include mq(false, $mq-sm - 1) {
          opacity: 1;
          bottom: -7px;
        }
      }
    }
    &:hover {
      @include mq($mq-sm) {
        :deep(.sc-variants__color-label) {
          bottom: -7px;
          opacity: 1;
        }
      }
    }
  }
}
</style>
